import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Platform_Module_Config.css';

const Platform_Module_Config = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"PLATFORM_MODULE_CONFIG",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	PLATFORM_MODULE_CONFIG:-1
  });


  const [PLATFORM_MODULE_CONFIG, setPLATFORM_MODULE_CONFIG] = React.useState(null);
  const [PLATFORM_MODULE_CONFIG_D, setPLATFORM_MODULE_CONFIG_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Platform Module Configuration');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPLATFORM_MODULE_CONFIG(clientInfo,"OpenNew");

		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Platform_Module_Config_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPLATFORM_MODULE_CONFIG(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPLATFORM_MODULE_CONFIG(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPLATFORM_MODULE_CONFIG(clientInfo,"OpenNew");
		}
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Platform_Module_Config_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Platform_Module_Config_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Platform_Module_Config_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
		if(Temp_Data2.status!="New"){
			handleDeletePLATFORM_MODULE_CONFIG(Temp_Data2);
			navigate('/Platform_Module_Config#New',{replace:true});
		} 
		else 
			navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Platform_Module_Config',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!PLATFORM_MODULE_CONFIG) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [PLATFORM_MODULE_CONFIG]) ;


  
  
  var Ids = [];
  for(var Ele in PLATFORM_MODULE_CONFIG){
	  for(var Sec in PLATFORM_MODULE_CONFIG[Ele]){
		if(Sec == "id")
			Ids.push(PLATFORM_MODULE_CONFIG[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(PLATFORM_MODULE_CONFIG[Ele]["status"]);
		else if(Array.isArray(PLATFORM_MODULE_CONFIG[Ele][Sec]))
			  for(var Row in PLATFORM_MODULE_CONFIG[Ele][Sec])  // Convert to PLATFORM_MODULE_CONFIG[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in PLATFORM_MODULE_CONFIG[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["PLATFORM_MODULE_CONFIG"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPLATFORM_MODULE_CONFIG(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG`).then((response1) => {
		if(!PLATFORM_MODULE_CONFIG) 
			setPLATFORM_MODULE_CONFIG(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG_D`).then((response2) => {
			setPLATFORM_MODULE_CONFIG_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPLATFORM_MODULE_CONFIG_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPLATFORM_MODULE_CONFIG = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPLATFORM_MODULE_CONFIG(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPLATFORM_MODULE_CONFIG = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPLATFORM_MODULE_CONFIG = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPLATFORM_MODULE_CONFIG = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePLATFORM_MODULE_CONFIG = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0"]=value;
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1"]=value;
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2"]=value;
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
  }; 
  

  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["4"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("4","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["4"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("4","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["5"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0"]=value;
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("5","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
  }; 
  

    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1"]=value;
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2"]=value;
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3"]=value;
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4"]=value;
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!PLATFORM_MODULE_CONFIG) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPLATFORM_MODULE_CONFIG =JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
  updatedPLATFORM_MODULE_CONFIG[Sec] = [...updatedPLATFORM_MODULE_CONFIG[Sec], newRow];
  setPLATFORM_MODULE_CONFIG(updatedPLATFORM_MODULE_CONFIG);
};

const handleDeleteRow = (sec,index) => {
  const updatedPLATFORM_MODULE_CONFIG = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
  updatedPLATFORM_MODULE_CONFIG[sec].splice(index, 1);
  setPLATFORM_MODULE_CONFIG(updatedPLATFORM_MODULE_CONFIG);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Platform Module Configuration`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Module Config ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Module Config ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0" type="text" className="form-control" placeholder="Module Config ID" value={PLATFORM_MODULE_CONFIG["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Module Config ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '60ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Module Code`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1" type="text" className="form-control" placeholder="Module Code" value={PLATFORM_MODULE_CONFIG["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '60ch' }}>
						 {t(`Enter Module Code`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Module Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2" type="text" className="form-control" placeholder="Module Name" value={PLATFORM_MODULE_CONFIG["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Module Name`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Module Category`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3"  value={PLATFORM_MODULE_CONFIG["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3`]} onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3_Change} className="form-control" name="Module Category"  >
						  <option value="Core">Core</option>
						  <option value="Compliance">Compliance</option>
						  <option value="Asset">Asset</option>
						  <option value="Offering">Offering</option>
						  <option value="Escrow">Escrow</option>
						  <option value="Investor">Investor</option>
						  <option value="Reporting">Reporting</option>
						  <option value="Operations">Operations</option>
						  <option value="Admin">Admin</option>
						  <option value="Token Subsystem">Token Subsystem</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Module Category
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Enabled`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["1"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4"] === "true" || PLATFORM_MODULE_CONFIG?.["1"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Applies to Rental Income Token`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To RENT INCOME TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0"] === "true" || PLATFORM_MODULE_CONFIG?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To REVENUE SHARE TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1"] === "true" || PLATFORM_MODULE_CONFIG?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To SALE PROFIT TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2"] === "true" || PLATFORM_MODULE_CONFIG?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To EQUITY APPRECIATION TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3"] === "true" || PLATFORM_MODULE_CONFIG?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Applies to Preferred Equity Token`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To PREFERRED EQUITY TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0"] === "true" || PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To COMMON EQUITY TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1"] === "true" || PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To DEBT NOTE TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2"] === "true" || PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To HYBRID TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3"] === "true" || PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To PRE AUCTION POOL TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4"] === "true" || PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To POST AUCTION TOKENIZATION`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5"] === "true" || PLATFORM_MODULE_CONFIG?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Requires Admin Approval`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Requires Admin Approval`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["4"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0"] === "true" || PLATFORM_MODULE_CONFIG?.["4"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Requires Compliance Approval`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1_Change} 
					  checked={PLATFORM_MODULE_CONFIG?.["4"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1"] === "true" || PLATFORM_MODULE_CONFIG?.["4"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Description`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '2000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Description`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0" type="text" className="form-control" placeholder="Description" value={PLATFORM_MODULE_CONFIG["5"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '2000ch' }}>
						 {t(`Enter Description`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0"  value={PLATFORM_MODULE_CONFIG["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0`]} onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1" type="text" className="form-control" placeholder="Created By" value={PLATFORM_MODULE_CONFIG["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2" type="text" className="form-control" placeholder="Created At" value={PLATFORM_MODULE_CONFIG["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3" type="text" className="form-control" placeholder="Updated By" value={PLATFORM_MODULE_CONFIG["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4" type="text" className="form-control" placeholder="Updated At" value={PLATFORM_MODULE_CONFIG["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Platform_Module_Config;  